<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    <h2>Dodaj placówkę</h2>
  </div>


  <div fxFlex="100">

    <app-partner-facility-select label="Placówka" [control]="partnerFacilityControl" [multiple]="false" [required]="false"
                                 [partnerIdString]="partnerId"></app-partner-facility-select>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

